<template lang="pug">
  div
    el-row(type='flex')
      el-col(:span="6").container-input
        app-label(label="Painel:", :required="false")
        el-select.input(
          filterable
          multiple
          collapse-tags
          :filter-method="filtrarPaineis"
          class="select"
          v-model="filtro.paineis"
          placeholder="Selecione"
          value-key="id"
        )
          el-option(
            v-for="painel in painelFiltradoList",
            :key="painel.id",
            :label="painel.nome",
            :value="painel"
        )

      el-col(:span="6").container-input
        app-label(label="Nome da demanda:", :required="false")
        el-input.input(
          v-model="filtro.nome"
          @blur="whitespace('nome')"
        )

      el-col(:span="6").container-input
        app-label(label="Responsável:", :required="false")
        el-select.input(
          filterable
          multiple
          collapse-tags
          :filter-method="filtrarResponsaveis"
          class="select"
          v-model="filtro.responsaveis"
          :disabled="!hasPainel"
          placeholder="Selecione"
          value-key="id"
        )
          el-option(
            v-for="item in responsavelFiltradoList",
            :key="item.id",
            :label="item.pessoa.nomeRazaoSocial",
            :value="item"
          )

      el-col(:span="6").container-input
        app-label(label="Número da demanda:", :required="false")
        el-input.input(
          v-model="filtro.id"
          :onkeypress="onlyInputNumbers"
        )

    el-row(type='flex')
      el-col(:span="6").container-input
        app-label(label="Prioridade da demanda:", :required="false")
        el-select.input(
          multiple
          collapse-tags
          class="select"
          v-model="filtro.prioridades"
          placeholder="Selecione"
          value-key="id"
        )
          el-option(
            v-for="item in prioridadeList",
            :key="item.id",
            :label="item.nome",
            :value="item"
          )

      el-col(:span="6").container-input
        app-label(label="Estado da demanda:", :required="false")
        el-select.input(
          multiple
          collapse-tags
          class="select"
          v-model="filtro.estados"
          placeholder="Selecione"
          value-key="id"
        )
          el-option(
            v-for="item in estadoDemandaList",
            :key="item.id",
            :label="item.nome",
            :value="item"
          )

      el-col(:span="6").container-input
        app-label(label="Situação da demanda:", :required="false")
        el-select.input(
          multiple
          collapse-tags
          class="select"
          v-model="filtro.situacoes"
          placeholder="Selecione"
          value-key="codigo"
        )
          el-option(
            v-for="item in situacaoList",
            :key="item.codigo",
            :label="item.nome",
            :value="item.codigo"
          )

      el-col(:span="6").container-input
        app-label(label="Data de entrega:", :required="false")
        el-date-picker(
          v-model="filtro.periodoEntrega"
          type="daterange"
          unlink-panels
          range-separator="até"
          start-placeholder="Início"
          end-placeholder="Fim"
          format="dd/MM/yyyy"
          :picker-options="pickerOptions"
        )

</template>

<script>
import AppLabel from '@/components/AppLabel'
import { mapActions } from 'vuex'
import AppOnlyInputNumbers from '@/components/mixins/AppOnlyInputNumbers'
import Utils from '@/utils/utils'

const UMA_SEMANA = new Date().getTime() - 3600 * 1000 * 24 * 7
const UM_MES = new Date().getTime() - 3600 * 1000 * 24 * 30
const TRES_MESES = new Date().getTime() - 3600 * 1000 * 24 * 90

export default {
  components: {
    AppLabel,
    Utils
  },

  mixins: [
    AppOnlyInputNumbers
  ],

  props: {
    filtro: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      responsavelList: [],
      responsavelFiltradoList: [],
      estadoDemandaList: [],
      prioridadeList: [],
      situacaoList: [
        {nome: 'Em dia', codigo: 'EM_DIA'},
        {nome: 'A vencer', codigo: 'A_VENCER'},
        {nome: 'Atrasada', codigo: 'ATRASADA'}
      ],
      painelList: [],
      painelFiltradoList: [],
      pickerOptions: {
        shortcuts: [{
          text: 'Última semana',
          onClick (picker) {
            const end = new Date()
            const start = UMA_SEMANA
            picker.$emit('pick', [start, end])
          }
        }, {
          text: 'Último mês',
          onClick (picker) {
            const end = new Date()
            const start = UM_MES
            picker.$emit('pick', [start, end])
          }
        }, {
          text: 'Últimos 3 meses',
          onClick (picker) {
            const end = new Date()
            const start = TRES_MESES
            picker.$emit('pick', [start, end])
          }
        }]
      }
    }
  },

  computed: {
    hasPainel () {
      return this.filtro.paineis && this.filtro.paineis.length > 0
    }
  },

  methods: {
    ...mapActions({
      findPrioridades: 'prioridades/findAll',
      findEstadosDemandas: 'estados/findAll',
      findTimesByPaineis: 'paineis/findTimesByPaineis',
      findPaineis: 'paineis/findAll'
    }),

    getPrioridades: async function () {
      this.prioridadeList = await this.findPrioridades()
    },

    getEstadosDemandas: async function () {
      this.estadoDemandaList = await this.findEstadosDemandas()
    },

    getPaineis: async function () {
      this.painelList = await this.findPaineis()
      this.painelFiltradoList = this.painelList
    },

    whitespace (field) {
      if (this.filtro[field]) {
        this.filtro[field] = this.filtro[field].trim()
      }
    },

    filtrarPaineis (filterValue) {
      this.painelFiltradoList = this.painelList.filter(item => {
        return Utils.normalize(item.nome).indexOf(Utils.normalize(filterValue)) > -1
      })
    },

    filtrarResponsaveis (filterValue) {
      this.responsavelFiltradoList = this.responsavelList.filter(item => {
        return Utils.normalize(item.pessoa.nomeRazaoSocial).indexOf(Utils.normalize(filterValue)) > -1
      })
    }
  },

  watch: {
    'filtro.paineis': {
      async handler () {
        if (this.hasPainel) {
          this.responsavelList = await this.findTimesByPaineis(this.filtro.paineis)
          this.responsavelFiltradoList = this.responsavelList
        } else {
          this.responsavelList = []
          this.responsavelFiltradoList = []
          this.filtro.responsaveis = []
          this.filtro.nome = ''
        }
      },
      deep: true
    }
  },

  mounted: function () {
    this.getPrioridades()
    this.getEstadosDemandas()
    this.getPaineis()
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/styles/_variables.scss";

.container {
  display: flex;
  flex-direction: row;
  padding: 5px;
}

.container-input {
  margin-right: 20px;
  margin-top: 0px;
  margin-bottom: 10px;
}

.select {
  width: 100%;
}

.el-date-editor--daterange.el-input__inner {
  width: 100%;
}
.el-date-editor >>> .el-range-separator {
  width: 20%;
}

.el-date-editor >>> .el-picker-panel__body {
  margin-left: 130px;
}

.el-date-editor
  >>> .el-picker-panel__body-wrapper
  >>> .el-picker-panel__sidebar {
  width: 130px;
}
</style>



// WEBPACK FOOTER //
// src/screens/demandas/components/PesquisaAvancadaDemandasRelatorio.vue